import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-jobs-quoted')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/quotes"
    infiniteScroll={true}
    message_if_none = 'No jobs in quote.'
    is_quote={true}
  />,
  document.getElementById('react-component-g4-logistics-portal-jobs-quoted'));
}
